import { useState, useEffect } from 'react';
import { getCurrentUser } from 'aws-amplify/auth';

export const useSubscriptionStatus = () => {
  const [subscriptionStatus, setSubscriptionStatus] = useState('free');
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkSubscriptionStatus = async () => {
      try {
        const currentUser = await getCurrentUser();
        setUser(currentUser);
        
        // Check if user has subscription data in localStorage
        const userSubscription = localStorage.getItem(`subscription_${currentUser.userId}`);
        
        if (userSubscription) {
          const subscriptionData = JSON.parse(userSubscription);
          setSubscriptionStatus(subscriptionData.status);
        } else {
          // Default to free for new users
          setSubscriptionStatus('free');
        }
      } catch (error) {
        console.log('User not authenticated');
        setSubscriptionStatus('free');
      } finally {
        setLoading(false);
      }
    };

    checkSubscriptionStatus();
  }, []);

  const updateSubscriptionStatus = (status) => {
    setSubscriptionStatus(status);
    if (user) {
      localStorage.setItem(`subscription_${user.userId}`, JSON.stringify({
        status,
        updatedAt: new Date().toISOString()
      }));
    }
  };

  const isPremium = subscriptionStatus === 'premium' || subscriptionStatus === 'paid';
  const isFree = subscriptionStatus === 'free';

  return {
    subscriptionStatus,
    isPremium,
    isFree,
    loading,
    user,
    updateSubscriptionStatus
  };
}; 